import BaseCamApi from "./BaseCamApi";

export default class NullCamApi extends BaseCamApi {
    constructor() {
        super('Null', {status: 'not_available'});
    }

    /**
     * @param {int} count
     * @param {string|null} gender
     * @returns {Promise<CamBanner[]>}
     */
    async getBanners(count, gender = null) {
        return [];
    }
};
